/* ==========================================================================
   Events > Resize
   ========================================================================== */

/**
 * Resize
 * Resize window event dispatch with a IE support
 */
function resizeWindow(delay = 1000) {
    setTimeout(() => {
        if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
            const evt = document.createEvent('UIEvents');

            evt.initUIEvent('resize', true, false, window, 0);

            window.dispatchEvent(evt);
        } else {
            window.dispatchEvent(new Event('resize'));
        }
    }, delay);
}

/* Exports */
module.exports = {
    resizeWindow
};
